import React, {Component, PureComponent} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import Preloader from '../../components/preloader';
import ScrollLoader from '../../components/scroll-loader';
import PhotoInfo from '../../containers/photo-info';
import Interior360Items from "./Interior360Items";
import './pannellum.css';
import './styles.css';
import {WINDOW} from "../../constants/environment";
//
/**
 *  Interior360
 */
class Interior360 extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    pcTitleText: PropTypes.string,
    mbTitleText: PropTypes.string,
    interior360Item: PropTypes.arrayOf(PropTypes.node),
    text360: PropTypes.string,
    icon360Src: PropTypes.string,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    pcTitleText: null,
    mbTitleText: null,
    interior360Item: null,
    text360: null,
    icon360Src: null,
  };

  constructor(props) {
    super();
    this.props = props;
    //
    const categories = (()=> {
      let categories = [];
      this.props.interior360Item.forEach((e)=> {
        if (e.props.categories && e.props.categories !== '') {
          categories.push(e.props.categories);
        }
      });
      return Array.from(new Set(categories));
      // return categories;
    })();
    const isMultipleLines = (()=> {
      let flg = false;
      this.props.interior360Item.forEach((e)=> {
        const pcInteriorName = e.props.pcInteriorName;
        // const mbInteriorName = e.props.mbInteriorName;
        if (pcInteriorName && pcInteriorName !== '') {
          if (0 <= pcInteriorName.indexOf('|')) {
            flg = true;
          }
        } else {
          // if (mbInteriorName && mbInteriorName !== '') {
          //   if (0 <= mbInteriorName.indexOf('|')) {
          //     flg = true;
          //   }
          // }
        }
      })
      return flg;
    })();
    const isSingleLines = (()=> {
      let flg = false;
      this.props.interior360Item.forEach((e)=> {
        const pcInteriorName = e.props.pcInteriorName;
        if (pcInteriorName && pcInteriorName !== '') {
          flg = true;
        }
      })
      return flg;
    })();
    // チップが1つのときはアイコンは表示しない、各カテゴリに2つ以上のアイコンがある場合は表示する
    const isViewIcons = (()=> {
      let arr = [];
      this.props.interior360Item.forEach((e)=> {
        let flg= true;
        let i, max;
        for (i = 0, max = arr.length; i < max; i = i + 1) {
          if (arr[i].categories === e.props.categories) {
            flg = false;
            arr[i].count += 1;
          }
        }
        if (flg) {
          arr.push({
            categories: e.props.categories,
            count: 1,
          })
        }
      })
      let i, max;
      for (i = 0, max = arr.length; i < max; i = i + 1) {
        if (2 <= arr[i].count) {
          return true;
        }
      }
      return false;
    })();
    const items = (()=> {
      if (!categories || categories.length <= 0) return this.props.interior360Item;
      let arr = [];
      this.props.interior360Item.forEach((child, index) => {
        if (child.props.categories === categories[0]) {
          arr.push(child);
        }
      })
      return arr;
    })();
    const variations = (()=> {
      let arr = [];
      const src = items[0].props.interiorViewImageSrc || null;
      const name = items[0].props.interiorViewName || null;
      if (src && src !== '') {
        arr.push({
          src: src,
          name: name,
        })
      }
      const subSrc = items[0].props.subInteriorViewImageSrc || null;
      const subName = items[0].props.subInteriorViewName || null;
      if (subSrc && subSrc !== '' && subName && subName !== '') {
        arr.push({
          src: subSrc,
          name: subName,
        })
      }
      return arr;
    })();
    //
    this.state = {
      currentCategoryIndex: 0,
      currentItemIndex: 0,
      currentVariationIndex: 0,
      isMultipleLines: isMultipleLines,
      isSingleLines: isSingleLines,
      isViewIcons: isViewIcons,
      categories: categories,
      items: items,
      variations: variations,
      loading: false,
      isScrollEnabled: false,
    };
    //
    this._intervalId = null;
    this._intervalId2 = null;
    this._intervalId3 = null;
    this._ref = React.createRef();
    this._container3 = React.createRef();
    this._categories = React.createRef();
    this._id = 'panorama' + Math.floor(Math.random() * 1000);

    this._viewer = null;
  }

  componentDidMount() {

    // 360ライブラリ読み込む
    if (0 <= String(location.hostname).indexOf('localhost') || 0 <= String(location.host).indexOf('3199')) {
      // https://pannellum.org/documentation/reference/
      const script = document.createElement('script');
      script.src = '/assets-dev/pannellum.js';
      script.async = true;
      document.body.appendChild(script);
    }

    if (this._intervalId) clearInterval(this._intervalId);
    this._intervalId = setInterval(()=> {
      if (window.pannellum && this._ref.current) {
        clearInterval(this._intervalId);
        this.setImage((()=> {
          const data = this.state.items[0].props;
          return data.interiorViewImageSrc
        })());
      }
    }, 500)

  }

  // カテゴリ変更
  changeCategory = (index)=> {
    //
    const items = (()=> {
      if (!this.state.categories || this.state.categories.length <= 0) return this.props.interior360Item;
      let arr = [];
      this.props.interior360Item.forEach((child) => {
        if (child.props.categories === this.state.categories[index]) {
          arr.push(child);
        }
      })
      return arr;
    })()
    //
    const variations = (()=> {
      let arr = [];
      const src = items[0].props.interiorViewImageSrc || null;
      const name = items[0].props.interiorViewName || null;
      if (src && src !== '') {
        arr.push({
          src: src,
          name: name,
        })
      }
      const subSrc = items[0].props.subInteriorViewImageSrc || null;
      const subName = items[0].props.subInteriorViewName || null;
      if (subSrc && subSrc !== '' && subName && subName !== '') {
        arr.push({
          src: subSrc,
          name: subName,
        })
      }
      return arr;
    })();
    //
    this.setState({
      currentCategoryIndex: index,
      currentItemIndex: 0,
      currentVariationIndex: 0,
      items: items,
      variations: variations,
    })
    // イメージ変更
    this.setImage((()=> {
      const data = items[0].props;
      // const data = this.state.items[0].props;
      return data.interiorViewImageSrc
    })());

    // フェードイン
    this._container3.current.classList.remove('opened');
    setTimeout(()=> {
      this._container3.current.classList.add('opened')
    }, 200)

    // スクロール
    if (this._categories.current) {
      const easing = (t, b, c, d) => {
        return c * ((t = t / d - 1) * t * t + 1) + b;
      }
      let time = 0;
      const li = this._categories.current.getElementsByTagName('li')[index];
      const target = (li.offsetLeft + (li.offsetWidth / 2)) - (this._categories.current.clientWidth / 2);
      const current = this._categories.current.scrollLeft;
      const sub = target - current;
      if (this._intervalId3) clearInterval(this._intervalId3);
      this._intervalId3 = setInterval(()=> {
        time = time + (1 / 30) * 2;
        if (1 < time) {
          clearInterval(this._intervalId3);
        } else {
          this._categories.current.scrollLeft = current + (easing(time, 0, 1, 1) * sub);
        }
      }, 1000 / 30)
    }

  }

  // アイテム変更
  onChangeItem = (index)=> {
    //
    const variations = (()=> {
      let arr = [];
      const src = this.state.items[index].props.interiorViewImageSrc || null;
      const name = this.state.items[index].props.interiorViewName || null;
      if (src && src !== '') {
        arr.push({
          src: src,
          name: name,
        })
      }
      const subSrc = this.state.items[index].props.subInteriorViewImageSrc || null;
      const subName = this.state.items[index].props.subInteriorViewName || null;
      if (subSrc && subSrc !== '' && subName && subName !== '') {
        arr.push({
          src: subSrc,
          name: subName,
        })
      }
      return arr;
    })();

    //
    this.setState({
      currentItemIndex: index,
      currentVariationIndex: 0,
      variations: variations,
    })

    // イメージ変更
    this.setImage((()=> {
      const data = this.state.items[index].props;
      return data.interiorViewImageSrc
    })());
  }

  // バリエーション変更
  changeVariation = (index)=> {
    this.setState({
      currentVariationIndex: index,
    })
    // イメージ変更
    this.setImage((()=> {
      const data = this.state.items[this.state.currentItemIndex].props;
      if (index === 0) {
        return data.interiorViewImageSrc;
      } else if (index === 1) {
        return data.subInteriorViewImageSrc;
      }
      return data.interiorViewImageSrc;
    })());
  }

  // イメージ変更
  setImage = (src) => {
    this.setState({
      loading: true,
    })

    // 要素を削除
    const parent = document.getElementById(this._id)
    while(parent.lastChild){
      parent.removeChild(parent.lastChild);
    }

    // 初期化
    if (this._viewer) {
      this._viewer.destroy();
    }

    this._viewer = pannellum.viewer(this._id, {
      type: 'equirectangular',
      autoLoad: true,
      showZoomCtrl: false,
      showFullscreenCtrl: false,
      showControls: false,
      yaw: -90,
      pitch: -14,
      panorama: src,
      // mouseZoom: true,
      mouseZoom: false,
    }).on('load', ()=> {

      // GTMイベント
      WINDOW.dataLayer = WINDOW.dataLayer || [];
      WINDOW.dataLayer.push({
        interior360_img: src,
        // interior360_img: '[' + src + ']',
        event: 'interior360_load'
      });

      setTimeout(()=> {
        this.setState({
          loading: false,
        })
      }, 500)
    })

  };

  render() {
    const {
      containerId,
      containerClass,
      pcTitleText,
      mbTitleText,
      text360,
      icon360Src,
    } = this.props;

    // タイトル表示
    const renderPcTitle = () => {
      const text = (pcTitleText && pcTitleText !== '') ? pcTitleText : null;
      if (text) {
        return (
          <div className="Interior360__title pc" dangerouslySetInnerHTML={{__html: text}} />
        )
      } else {
        return null;
      }
    }

    // タイトル表示
    const renderMbTitle = () => {
      let text = null;
      if (mbTitleText && mbTitleText !== '') {
        text = mbTitleText;
      } else if (pcTitleText && pcTitleText !== '') {
        text = pcTitleText;
      }
      if (text) {
        return (
          <div className="Interior360__title mb" dangerouslySetInnerHTML={{__html: text}} />
        )
      } else {
        return null;
      }
    }

    // カテゴリ表示
    const renderCategories = () => {
      if (!this.state.categories || this.state.categories.length <= 1) return null;
      return (
        <div className="Interior360__categories" ref={this._categories}>
          <ul className="Interior360__categories__list">{(()=> {
            return this.state.categories.map((val, i)=> {
              return (
                <li key={i} className={this.state.currentCategoryIndex === i ? 'current' : ''}>
                  <a className="Interior360__categories__link" href="javascript:void(0)" onClick={(e)=> {
                    e.preventDefault();
                    // カテゴリ変更
                    this.changeCategory(i);
                  }} dangerouslySetInnerHTML={{__html: val.replace('|', '<br />')}}/>
                </li>
                // <li key={i}>
                //   <a className={'Interior360__categories__link' + (this.state.currentCategoryIndex === i ? ' current' : '')} href="" onClick={(e)=> {
                //     e.preventDefault();
                //     // カテゴリ変更
                //     this.changeCategory(i);
                //   }}>{val}</a>
                // </li>
              )
            })
          })()}</ul>
        </div>
      )
    }

    // アイテム表示
    const renderItems = () => {
      return (
        <div className="Interior360__container3 opened" ref={this._container3}>
          <Interior360Items
            currentItemIndex={this.state.currentItemIndex}
            items={this.state.items}
            isMultipleLines={this.state.isMultipleLines}
            isSingleLines={this.state.isSingleLines}
            onChangeItem={(index)=> {
              this.onChangeItem(index);
            }}
            isViewIcons={this.state.isViewIcons}
          />
        </div>
      )
    }

    // ビューアー表示
    const renderViewer = () => {
      return (
        <div className="Interior360__viewer" id={this._id} />
      )
      // const data = this.state.items[this.state.currentItemIndex].props;
      // return (
      //   <div className="Interior360__viewer">
      //     <img src={(()=> {
      //       if (this.state.currentVariationIndex === 0) {
      //         return data.interiorViewImageSrc;
      //       } else if (this.state.currentVariationIndex === 1) {
      //         return data.subInteriorViewImageSrc;
      //       } else {
      //         return data.interiorViewImageSrc;
      //       }
      //     })()} alt=""/>
      //   </div>
      // )
    }

    // アイコン表示
    const renderIcon = () => {
      return (
        <p className="Interior360__icon"><img src={icon360Src} alt="" />{text360}</p>
      )
    }

    // バリエーション表示
    const renderVariation = () => {
      if (!this.state.variations || this.state.variations.length <= 1) return null;
      return (
        <div className="Interior360__variation">
          <ul className="Interior360__variation__list">
            {(()=> {
              return this.state.variations.map((e, i)=> {
                return (
                  <li key={i}>
                    <a className={'Interior360__variation__link' + (this.state.currentVariationIndex === i ? ' current' : '')} href="" onClick={(e)=> {
                      e.preventDefault();
                      // バリエーション変更
                      this.changeVariation(i);
                    }}>{e.name}</a>
                  </li>
                )
              })
            })()}
          </ul>
        </div>
      )
    }

    // バリエーション表示
    const renderVariationMb = () => {
      if (!this.state.variations || this.state.variations.length <= 1) return null;
      return (
        <div className="Interior360__variation-mb">
          <ul className="Interior360__variation-mb__list">
            {(()=> {
              return this.state.variations.map((e, i)=> {
                return (
                  <li key={i}>
                    <a className={'Interior360__variation-mb__link' + (this.state.currentVariationIndex === i ? ' current' : '')} href="" onClick={(e)=> {
                      e.preventDefault();
                      // バリエーション変更
                      this.changeVariation(i);
                    }}>{e.name}</a>
                  </li>
                )
              })
            })()}
          </ul>
        </div>
      )
    }

    // PhotoInfo表示
    const renderPhotoInfo = () => {
      const data = this.state.items[this.state.currentItemIndex].props;
      if (!data.photoInfo || !data.photoInfo[0] || !data.photoInfo[0].props) return null;
      return (
        <div className="Interior360__photo-info">
          <PhotoInfo {...data.photoInfo[0].props} />
        </div>
      )
    }

    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <ScrollLoader>
          <section className="Interior360" ref={this._ref}>
            <div className="Interior360__container">
              <div className="Wysiwyg">
                {renderPcTitle()}
                {renderMbTitle()}
              </div>
              {renderCategories()}
              {renderItems()}
              <div className="Interior360__container2">
                {renderViewer()}
                <Preloader loading={this.state.loading}/>
                {renderVariation()}
                {renderIcon()}
                {renderPhotoInfo()}
              </div>
            {renderVariationMb()}
            </div>
          </section>
        </ScrollLoader>
      </Wrapper>
    )
  }

}

export default Interior360;



// WEBPACK FOOTER //
// ./src/containers/interior360/index.jsx